'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    alert: {
        requiredprops: []
    },
    alertdialog: {
        requiredprops: []
    },
    application: {
        requiredprops: []
    },
    article: {
        requiredprops: []
    },
    banner: {
        requiredprops: []
    },
    button: {
        requiredprops: []
    },
    checkbox: {
        requiredprops: ['aria-checked']
    },
    columnheader: {
        requiredprops: []
    },
    combobox: {
        requiredprops: ['aria-expanded']
    },
    complementary: {
        requiredprops: []
    },
    contentinfo: {
        requiredprops: []
    },
    definition: {
        requiredprops: []
    },
    dialog: {
        requiredprops: []
    },
    directory: {
        requiredprops: []
    },
    document: {
        requiredprops: []
    },
    form: {
        requiredprops: []
    },
    grid: {
        requiredprops: []
    },
    gridcell: {
        requiredprops: []
    },
    group: {
        requiredprops: []
    },
    heading: {
        requiredprops: []
    },
    img: {
        requiredprops: []
    },
    link: {
        requiredprops: []
    },
    list: {
        requiredprops: []
    },
    listbox: {
        requiredprops: []
    },
    listitem: {
        requiredprops: []
    },
    log: {
        requiredprops: []
    },
    main: {
        requiredprops: []
    },
    marquee: {
        requiredprops: []
    },
    math: {
        requiredprops: []
    },
    menu: {
        requiredprops: []
    },
    menubar: {
        requiredprops: []
    },
    menuitem: {
        requiredprops: []
    },
    menuitemcheckbox: {
        requiredprops: []
    },
    menuitemradio: {
        requiredprops: []
    },
    navigation: {
        requiredprops: []
    },
    note: {
        requiredprops: []
    },
    option: {
        requiredprops: []
    },
    presentation: {
        requiredprops: []
    },
    progressbar: {
        requiredprops: []
    },
    radio: {
        requiredprops: []
    },
    radiogroup: {
        requiredprops: []
    },
    region: {
        requiredprops: []
    },
    row: {
        requiredprops: []
    },
    rowgroup: {
        requiredprops: []
    },
    rowheader: {
        requiredprops: []
    },
    scrollbar: {
        requiredprops: ['aria-controls', 'aria-orientation', 'aria-valuemax', 'aria-valuemin', 'aria-valuenow']
    },
    search: {
        requiredprops: []
    },
    separator: {
        requiredprops: []
    },
    slider: {
        requiredprops: ['aria-valuemax', 'aria-valuemin', 'aria-valuenow']
    },
    spinbutton: {
        requiredprops: ['aria-valuemax', 'aria-valuemin', 'aria-valuenow']
    },
    status: {
        requiredprops: []
    },
    tab: {
        requiredprops: []
    },
    tablist: {
        requiredprops: []
    },
    tabpanel: {
        requiredprops: []
    },
    textbox: {
        requiredprops: []
    },
    timer: {
        requiredprops: []
    },
    toolbar: {
        requiredprops: []
    },
    tooltip: {
        requiredprops: []
    },
    tree: {
        requiredprops: []
    },
    treegrid: {
        requiredprops: []
    },
    treeitem: {
        requiredprops: []
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y/lib/util/role.js
// module id = 1622
// module chunks = 100 101